import React from "react";
import Lottie from "react-lottie";
import animationData from "../assets/json/live-stream.json";
export default function LiveStream() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div
      className="text-center liveStreamRedIcon "
      style={{ pointerEvents: "none" }}
    >
      <Lottie options={defaultOptions} />
    </div>
  );
}
